import { AgTable, Pagination } from '@navi/web-ui/lib/components';
import { AgentAvailabilityHistoryColumns } from './HistoryColDefs';
import { useEffect, useMemo, useRef, useState } from 'react';
import { DropDownPosition } from '@navi/web-ui/lib/components/Pagination/constant';
import { IAvailabilityHistoryData, IAvailabilityHistoryParams } from '../../constants/types';
import { RootState } from '@cp/src/store';
import { useSelector } from 'react-redux';
import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ViewType } from '../../constants';

const HistoryMainContent = (props: IAvailabilityHistoryParams) => {
  const { urlParams, updateAndNavigate } = props;

  const gridRef = useRef<AgGridReact>(null);
  const availabilityHistory = useSelector(
    (state: RootState) => state?.agentAvailabilitySlice?.agentAvailablityHistoryData
  );
  const availability = useSelector((state: RootState) => state?.agentAvailabilitySlice);
  const [filteredRowData, setFilteredRowData] =
    React.useState<Array<IAvailabilityHistoryData>>(availabilityHistory);
  const [totalElements, setTotalElements] = React.useState(0);

  const retainPageChange = (filteredData: IAvailabilityHistoryData[]) => {
    const pageNumber = Number(urlParams?.pageNo) || 1;
    const pageSize = Number(urlParams?.pageSize) || 50;
    const startIndex = (pageNumber - 1) * pageSize;
    const endIndex = pageNumber * pageSize;
    const updatedData = filteredData?.slice(startIndex, endIndex) || [];
    setTotalElements(filteredData?.length || 0);
    setFilteredRowData(updatedData);
  };

  const handlePageChange = (pageNo: number) => {
    if (!urlParams) return;
    const updatedParams = { ...urlParams };
    updatedParams['pageNo'] = String(pageNo);
    updateAndNavigate(updatedParams);
  };

  const handleSizeChange = (pageSize: number) => {
    if (!urlParams) return;
    const updatedParams = { ...urlParams };
    updatedParams['pageNo'] = '1';
    updatedParams['pageSize'] = String(pageSize);
    updateAndNavigate(updatedParams);
  };

  useEffect(() => {
    setFilteredRowData(availabilityHistory);
  }, [availabilityHistory]);

  useEffect(() => {
    let dataToShow = availabilityHistory;
    if (urlParams?.agentId) {
      dataToShow =
        availabilityHistory?.filter(item => item.agentReferenceId === urlParams.agentId) || [];
    }

    retainPageChange(dataToShow);
  }, [availabilityHistory, urlParams?.agentId, urlParams?.pageNo, urlParams?.pageSize]);

  const currentPage = Number(urlParams?.pageNo) || 1;
  const pageSize = Number(urlParams?.pageSize) || 50;

  const columnDefs = useMemo(() => {
    return AgentAvailabilityHistoryColumns(urlParams);
  }, [urlParams?.radioOption, urlParams?.startDate]);

  useEffect(() => {
    gridRef?.current?.api?.sizeColumnsToFit();
  }, [columnDefs]);

  return (
    <div className="historyTable">
      <AgTable
        key={urlParams?.radioOption || urlParams?.pageNo || urlParams?.startDate}
        ref={gridRef}
        defaultColDef={{
          suppressMovable: true,
          wrapText: true,
          autoHeight: true
        }}
        style={{
          height: 'calc(100vh - 250px)'
        }}
        rowData={filteredRowData || []}
        columnDefs={columnDefs}
        animateRows={true}
        alternateRowColor="var(--greyscale-content-4)"
        theme={'alpine'}
        sizeColumnsToFit={true}
        paginationWrapperClasses={'paginationWrapperClasses'}
        PaginationComponent={
          <Pagination
            totalCount={totalElements}
            onPageChange={handlePageChange}
            currentPage={currentPage}
            onPageSizeChange={handleSizeChange}
            pageSize={pageSize}
            pageNumberDropDownPosition={DropDownPosition.TOP}
            containerClasses="w-[100%]"
          />
        }
      />
    </div>
  );
};

export default HistoryMainContent;
